var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticClass:"horizontalstyle",attrs:{"id":"inspire"}},[_c('vertical-header',{attrs:{"user":_vm.user}}),_c('v-main',[_c('v-container',{staticClass:"page-wrapper",attrs:{"fluid":""}},[_c('router-view')],1)],1),_c('vertical-sidebar'),_c('base-loading')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }